import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { Notification } from '@/hooks/api/models';

/**
 * 2100. ダッシュボード（売上カテゴリ別案件数）
 * [GET] /workspaces/:identifier/dashboard/count_by_product
 */
type Props = {
  identifier: string;
  team_ids?: number[];
  user_ids?: number[];
  product_ids?: number[];
  sales_context_ids?: number[];
};

export type DashboardCountByProduct = {
  names: string[];
  counts: number[];
};

const dashboardCountByProduct = (props: Props): Promise<DashboardCountByProduct> => {
  return axios.get(`/api/workspaces/${props.identifier}/dashboard/count_by_product`, { params: props });
};

export const useDashboardCountByProduct = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'dashboard', 'count_by_product', { ...props }],
    queryFn: () => dashboardCountByProduct(props),
    staleTime: 1000 * 60 * 30,
  });
};
